<template>
  <div class="PracticeBase" v-html="resData.instructions">
    <!-- <div class="cont_title">
      一、基地名称：广州统计师事务所
    </div>
    <div class="cont_row">
      基地成立时间：2023年7月3日

    </div>
    <div class="cont_row">
      简介：广州统计师事务所是一家对外开展统计调查和提供信息咨询服务的国有企业，作为具备本地化服务能力和拥有良好商业信誉及丰富业务经验的专业机构，始终坚持利用统计数据和网络资源，为社会各界提供精准统计调查服务，同时在项目质量、服务等方面得到广州市委、市政府、市人大、市政协、省统计局、市统计局、市规划和自然资源局、市人力资源和社会保障局、市商务局、市环保局、市交通运输局等近100个客户的好评。

    </div>
    <div class="cont_row cont_row1">
      <div class="cont_label">电话：</div>
      <div class="cont_value">19202095032</div>
    </div>
    <div class="cont_row cont_row1">
      <div class="cont_label">E-mail：</div>
      <div class="cont_value"> editor_asds@gztjssws.com</div>
    </div>
    <div class="cont_row cont_row1">
      <div class="cont_label">地址：</div>
      <div class="cont_value"> 广州市越秀区文德路67号金德大厦9楼</div>
    </div>
    <div class="cont_title"></div>
    <div class="cont_title">
      二、部分项目案例
    </div>
    <div class="cont_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" label="序号" type='index' width="50">
        </el-table-column>
        <el-table-column prop="name" label="委托方" width="350">
        </el-table-column>
        <el-table-column prop="project" label="项目名称">
        </el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PracticeBase',
  data () {
    return {
      resData: {},
      // tableData: [{
      //   name: '广州市、各区及街道',
      //   project: '共完成26个全国第五次经济普查服务项目'
      // }, {

      //   name: '广东省统计局',
      //   project: '广东省第五次全国经济普查资料开发'
      // }, {
      //   name: '广东省统计局',
      //   project: '广东省城乡一体化调查服务外包'
      // }, {
      //   name: '中共广东省委军民融合发展委员会办公室',
      //   project: '中共广东省委军民融合发展委员会办公室统计服务项目'
      // }]
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const that = this
      this.$request.getBaseList().then((res) => {
        if (res.code === 200) {
          // console.log(res)
          that.$set(that, 'resData', res.data)
        }
      })
    }
  },
}
</script>

<style lang="scss" >
.PracticeBase {
  position: relative;
  font-size: 16px;
  color: #666666;
  strong {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    line-height: 2;
    padding: 0 0 20px;
  }
  p {
    font-weight: 400;

    line-height: 1.5;
  }
  table {
    width: 100% !important;
    border-collapse: collapse;
    border: 1px solid #ddd; /* 整体边框颜色 */
  }
  th,
  td {
    box-sizing: border-box;
    line-height: 40px; /* 行高 */
    border: 1px solid #ddd; /* 每行边框 */
    font-size: 16px;
    padding: 8px 10px;
    vertical-align: middle !important;
  }
  th {
    background-color: #d2d2d2; /* 表头背景色 */
    p,
    td p {
      color: #333333;
    }
  }
  tr:first-child {
    background-color: #d2d2d2 !important; /* 表头背景色 */
    p,
    td p {
      color: #333333;
    }
  }
  tr:hover {
    background-color: #efefef; /* 鼠标悬停时的背景色:蓝色 */
  }
}
</style>